// Lab reference values — schemas + inferred types.
//
// FIRST Zod-in-types pilot. The schema is authoritative — the TS type is
// derived via z.infer<>. Consumers can:
//   - import { LabValue, LabCategory } for compile-time typing (unchanged from
//     the pre-migration API)
//   - import { LabValueSchema, LabCategorySchema } for runtime validation of
//     API responses, form input, or Firestore reads
//
// Data (LAB_VALUES) is NOT exported from here — it lives in the backend
// (apps/backend/src/data/labValues.ts) and is served via /api/lab-values.
// Only the shape lives in @q4udoc/types.

import { z } from 'zod';

export const LabValueSchema = z.object({
  name: z.string().min(1),
  normalRange: z.string(), // allows quirky formats like "<200", "Negative"
  unit: z.string(), // allows empty string (INR, pH have no unit)
  notes: z.string().optional(),
});

export type LabValue = z.infer<typeof LabValueSchema>;

export const LabCategorySchema = z.object({
  category: z.string().min(1),
  values: z.array(LabValueSchema).min(1),
});

export type LabCategory = z.infer<typeof LabCategorySchema>;
